import styled from 'styled-components';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { ScrollContainer } from 'foundations-components/transitional/components/ScrollContainer';
import { Text } from 'foundations-components/components/Text';
import { Flex } from 'foundations-components/components/Flex';
import { Box } from 'foundations-components/transitional/components/Box';
import UISearchInput from 'UIComponents/input/UISearchInput';
import UILoadingDots from 'UIComponents/loading/UILoadingDots';
import UIButton from 'UIComponents/button/UIButton';
import SelectionPanelOptionButton from 'automation-ui-canvas/create/SelectionPanelOptionButton';
import SelectionPanelButton from 'automation-ui-canvas/create/SelectionPanelButton';
import SelectionPanelGroup from 'automation-ui-canvas/create/SelectionPanelGroup';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const SelectionPanelContainer = styled.div.withConfig({
  displayName: "SelectionPanel__SelectionPanelContainer",
  componentId: "sc-1bg68j1-0"
})(["display:flex;flex-direction:column;height:100%;margin:0 calc(0px - ", ");"], ({
  theme
}) => theme.space['800']);
export default function SelectionPanel({
  heading,
  subHeading,
  options,
  searchTerm,
  onSearchTermChange,
  additionalFilters = null,
  onSelectOption,
  loading,
  hasMore,
  loadMore,
  headingAction = null,
  emptyState
}) {
  let footer = null;
  if (loading) {
    footer = /*#__PURE__*/_jsx(UILoadingDots, {
      minHeight: 40,
      grow: false,
      className: "m-x-12"
    });
  } else if (hasMore && loadMore) {
    footer = /*#__PURE__*/_jsx(SelectionPanelButton, {
      onClick: loadMore,
      children: /*#__PURE__*/_jsx(UIButton, {
        use: "link",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "createWorkflow.selectionPanel.loadMore"
        })
      })
    });
  } else if (options.length === 0) {
    footer = !searchTerm && emptyState ? /*#__PURE__*/_jsx("div", {
      className: "p-x-8",
      children: emptyState
    }) : /*#__PURE__*/_jsx(SelectionPanelButton, {
      disabled: true,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "createWorkflow.selectionPanel.noResults"
      })
    });
  }
  return (
    /*#__PURE__*/
    // @bend-expect trellis-tokenized
    _jsxs(SelectionPanelContainer, {
      children: [/*#__PURE__*/_jsxs(Box, {
        shrink: "0",
        paddingInline: "800",
        marginBlockEnd: "400",
        children: [/*#__PURE__*/_jsxs(Flex, {
          justifyContent: "space-between",
          alignItems: "baseline",
          children: [/*#__PURE__*/_jsx(Box, {
            grow: "1",
            children: /*#__PURE__*/_jsx(Text, {
              as: "h5",
              children: heading
            })
          }), headingAction]
        }), subHeading && /*#__PURE__*/_jsx(Text, {
          typography: "detail-200",
          color: "text-core-subtle",
          marginBlockStart: "100",
          children: subHeading
        }), additionalFilters, /*#__PURE__*/_jsx(UISearchInput, {
          className: "m-top-3",
          value: searchTerm,
          onChange: ({
            target: {
              value
            }
          }) => onSearchTermChange(value),
          autoFocus: true
        })]
      }), /*#__PURE__*/_jsxs(ScrollContainer, {
        scrollDirection: "vertical",
        children: [options.map((option, index) => {
          if ('value' in option) {
            return /*#__PURE__*/_jsx(SelectionPanelOptionButton, {
              option: option,
              onClick: () => onSelectOption(option)
            }, option.value);
          } else {
            return /*#__PURE__*/_jsx(SelectionPanelGroup, {
              group: option,
              onSelectOption: onSelectOption,
              hasSearchTerm: !!searchTerm
            }, index);
          }
        }), footer]
      })]
    })
  );
}